import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { IconButton, Text } from 'react-native-paper';

import { BackIcon, CloseIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type Props = {
  step: number;
  onBackPress: () => void;
  onClosePress?: () => void;
};

export const OrganizationCreateHeader: FC<Props> = ({
  step,
  onBackPress,
  onClosePress
}) => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-create'
  });
  const stepTitle =
    step === 0 ? t('steps.organizationData') : t('steps.adminSetup');

  return (
    <>
      <IconButton
        key="header-button"
        style={{
          alignSelf: step > 0 ? 'flex-start' : 'flex-end',
          margin: 0
        }}
        icon={({ color, size }) =>
          step > 0 ? (
            <BackIcon fill={color} width={size} height={size} />
          ) : (
            <CloseIcon fill={color} width={size} height={size} />
          )
        }
        onPress={step > 0 ? onBackPress : onClosePress}
      />
      <Text style={styles.title} variant="headlineLarge">
        {stepTitle}
      </Text>
      {step === 0 && (
        <Text style={styles.description} variant="titleMedium">
          {t('description')}
        </Text>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  title: {
    textAlign: 'center',
    paddingTop: 8,
    paddingBottom: 8
  },
  description: {
    textAlign: 'center',
    paddingBottom: 8,
    fontWeight: 'bold'
  }
});
